import React from 'react';
import moment from 'moment';
import toUpper from 'lodash/toUpper';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { Segment } from '@fxtr/i18n';
import Tag from '$app/apps/bookings/components/Tag';
import { isNotificationMarker } from '$app/core/utils/noteNotification';
import { BOOKING_STATUS } from '$app/apps/bookings/containers/BookingPage/constants';
import { HeaderRow, driverAllocationColors as colors } from './styled';

const isHighPriority = (priority) => (priority > 20 ? <img src="/assets/icons/warning-icon.svg" /> : '');
const getPriorityStyle = (priority) => {
  if (priority <= 10) return 'low_priority';
  if (priority <= 20) return 'normal_priority';
  return 'high_priority';
};
const getCaseManagerInitials = ({ caseManagerId }, caseManagers) => {
  const cm = caseManagers.find((m) => m.userId === caseManagerId);
  if (cm && cm.name && cm.givenName) return `${cm.name.slice(0, 1)} ${cm.givenName.slice(0, 1)} -`;
  if (typeof caseManagerId === 'string')
    return `${caseManagerId
      .split('.')
      .map((n) => n.slice(0, 1))
      .join('')} -`;

  return null;
};

const GarageInviteStatus = ({ invitations }) => {
  let tag = <Tag color="red">UNALLOCATED</Tag>;
  const garageStr = <b>Garage</b>;

  if (!invitations || invitations.length === 0) {
    return (
      <HeaderRow>
        {garageStr} {tag}
      </HeaderRow>
    );
  }

  const lastInvite = invitations.sort((a, b) => (a.creationDateTime > b.creationDateTime ? -1 : 1))[0];
  tag = <Tag color={colors[lastInvite.status]}>{lastInvite.status.toUpperCase()}</Tag>;

  return (
    <HeaderRow>
      {garageStr} {tag}
    </HeaderRow>
  );
};

const DriverInviteStatus = ({ collectionDeliveryOption, trips }) => {
  if (collectionDeliveryOption === 'Fixter') {
    if (!trips || trips.length === 0) {
      return (
        <HeaderRow>
          <b>Driver</b>{' '}
          <Tag size="small" color="grey">
            NO TRIPS YET
          </Tag>
        </HeaderRow>
      );
    }

    const unallocatedTrip = trips.find(
      (trip) => trip.status === 'active' && trip.allocationStatus !== 'accepted'
    );

    return (
      <HeaderRow>
        <b>Driver</b>{' '}
        <Tag color="red">
          {((unallocatedTrip && unallocatedTrip.allocationStatus) || 'unknown').toUpperCase()}
        </Tag>
      </HeaderRow>
    );
  }

  return (
    <HeaderRow>
      <b>{collectionDeliveryOption}</b>
    </HeaderRow>
  );
};

const Header = (props) => {
  const { booking, toggleCollapse, caseManagers, currentUser, laneId, template } = props;
  const {
    customer,
    partner,
    detailedStatus,
    notes,
    caseManagerId,
    masterStatusId,
    paymentMethod,
    tags = [],
    segment,
    garageInvites,
    collectionDeliveryOption,
    trips,
    collectionDateTimeLocal,
    collectionAddress,
    garage,
  } = booking;
  const { firstName, lastName, mobileNumber } = customer;

  const bookingPage = `/bookings/${booking.bookingId}`;

  let paymentImage = null;
  if (
    masterStatusId >= BOOKING_STATUS.WORK_COMPLETE &&
    masterStatusId != BOOKING_STATUS.CANCELLED &&
    masterStatusId != BOOKING_STATUS.GARAGE_DECLINED
  ) {
    const mapStatusToImage = {
      failed: '/assets/images/payment_failed.png',
      deleted: '/assets/images/payment_failed.png',
      unpaid: '/assets/images/awaiting_payment.png',
      locked: '/assets/images/awaiting_payment.png',
      paid: '/assets/images/payment_succeded.png',
    };
    paymentImage = mapStatusToImage[paymentMethod.status];
  } else if (tags.includes('stayover')) {
    paymentImage = '/assets/images/stayover.svg';
  }

  return (
    <div className="card-header">
      <Link to={bookingPage}>
        <div className="name-status" onClick={() => {}}>
          <p className="customer-name">
            {segment === Segment.Fixter_FR ? '🇫🇷' : '🇬🇧'}
            <span title={mobileNumber}>
              {firstName} {lastName}
            </span>
            &nbsp;{partner && <Tag>{partner}</Tag>}
          </p>
          {(template === 'dashboard' && (
            <p id="detailed-status" className={getPriorityStyle(detailedStatus.priority)}>
              {!isEmpty(caseManagers) && toUpper(getCaseManagerInitials(booking, caseManagers))}{' '}
              {detailedStatus.friendlyName} {isHighPriority(detailedStatus.priority)}
            </p>
          )) || (
            <>
              {detailedStatus.priority > 20 && (
                <HeaderRow>
                  <Tag color="#d64040">⚠️ CALL GARAGES</Tag>
                </HeaderRow>
              )}
              <GarageInviteStatus invitations={garageInvites} />
              <DriverInviteStatus collectionDeliveryOption={collectionDeliveryOption} trips={trips} />
              <span className="time-postcode">
                {moment(collectionDateTimeLocal).format('DD MMM YYYY')} / {booking.collectionAddress.postcode}
                <br />
                {laneId === 'driverToAllocate' && booking.garage.businessName}
              </span>
            </>
          )}
        </div>
      </Link>
      {paymentImage ? (
        <img
          height="22px"
          src={paymentImage}
          style={{
            verticalAlign: 'top',
            position: 'absolute',
            right: 28,
          }}
          alt="Payment icon"
        />
      ) : null}
      <span onClick={toggleCollapse} className="toggle-btn" />
      <br />
      {isNotificationMarker(notes, currentUser, caseManagerId) && (
        <i
          className="icon-note pull-right"
          style={{ color: '#58b0ff', marginTop: -20, fontWeight: 'bold' }}
        />
      )}
    </div>
  );
};

export default Header;
